/**
 * @file 标记卡和反向标记卡
 * @author chenyuyang
 */
import React from 'react';
import PropTypes from 'prop-types';
import iconPhone from '../../imgs/icon-phone.svg';
import iconReversePhone from '../../imgs/icon-reverse-phone.svg';
import iconWarn from '../../imgs/warn-icon-16.svg';

import {reverseReportList} from '../../constans';
import './style.less';
const Report = (props) => {
    const {search, data = {}} = props;
    const {location = {}, reports = []} = data;
    const reverse = reverseReportList.includes(reports[0].tag);
    const local = location?.province ? ((location?.province || '') + ' ' + (location.area[0]?.city || '')) : '未知归属地';
    const tipText = reports[0].tip?.text || '';
    return (
        <div className="comp-report">
            <p className="tel-num">{search}</p>
            {tipText && <div className="page-tip">
                <img className="icon-warn" src={iconWarn} />
                {tipText}
            </div>}
            <div className="tel-info">
                <img className="icon" src={reverse ? iconReversePhone : iconPhone}></img>
                <div className="info-right">
                    <div className="report-wrapper">
                        <span className="report-name">{reports[0].tag || ''}</span>
                        <span className={'report-type ' + (reverse ? 'reverse-report-type' : '')}>
                            {reports[0].landing_page_text || ''}
                        </span>
                    </div>
                    <p className="location">{local}</p>
                </div>
            </div>
        </div>
    );
};
Report.propTypes = {
    search: PropTypes.string,
    data: PropTypes.any
};
export default Report;